import type { SVGProps } from "react";
export interface GlassesWineIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function GlassesWineIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: GlassesWineIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.048 7.64a1.124 1.124 0 0 1 .391 2.216l-5.745 1.012-.114.015a1.126 1.126 0 0 1-.277-2.23zM2.653 6.652c.108-.611.69-1.02 1.302-.912L9.7 6.752l.113.026a1.125 1.125 0 0 1-.39 2.205l-.114-.015-5.743-1.013-.113-.025a1.125 1.125 0 0 1-.8-1.278M14.375 21a1.374 1.374 0 0 1-2.742.141l-.008-.14.008-.141A1.375 1.375 0 0 1 13 19.625l.139.007c.693.07 1.235.656 1.235 1.368Zm-3-4a1.375 1.375 0 0 1-2.743.14L8.625 17l.007-.14a1.376 1.376 0 0 1 1.369-1.236l.139.008c.694.07 1.235.656 1.235 1.368"
      />
      <path
        fill={color}
        d="M18.984 2.77c.494.008.938.344 1.069.838l2.175 8.26a4.345 4.345 0 0 1-2.366 5.045l.59 3.346 1.356-.237a1.125 1.125 0 0 1 .39 2.216l-4.924.867a1.124 1.124 0 0 1-.39-2.215l1.352-.24-.59-3.345a4.346 4.346 0 0 1-3.946-3.932l-.78-8.506a1.124 1.124 0 0 1 .925-1.21l4.925-.869zM5.234.888l4.924.867c.576.102.98.63.926 1.212l-.78 8.506a4.35 4.35 0 0 1-3.949 3.932l-.59 3.345 1.355.24a1.126 1.126 0 0 1-.391 2.217l-4.924-.869-.112-.026a1.125 1.125 0 0 1 .388-2.205l.114.015 1.354.237.59-3.345a4.346 4.346 0 0 1-2.364-5.045l2.176-8.26.075-.203A1.125 1.125 0 0 1 5.235.888Zm10.02 4.803.686 7.477a2.096 2.096 0 1 0 4.113-.727l-1.915-7.26zM3.95 10.541a2.097 2.097 0 1 0 4.113.726l.684-7.476-2.884-.51z"
      />
    </svg>
  );
}
